import { render } from "./AppBar.vue?vue&type=template&id=401dc578"
import script from "./AppBar.vue?vue&type=script&lang=ts"
export * from "./AppBar.vue?vue&type=script&lang=ts"
script.render = render

export default script